import { useEffect } from 'react';
import { pageSessionKey, loginPageValue } from '@/constants';

export const useHeaderLoginListener = (id) => {
  useEffect(() => {
    const ele = document.querySelector(id);
    if (ele) {
      ele.addEventListener('click', () => {
        window.sessionStorage.setItem(pageSessionKey, loginPageValue);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on initial render
  }, []);
};
